module.exports = require('./dist/echarts-amap.min.js')
